<template>
  <router-view />
</template>

<script>

export default {
  name: 'HotelManagementHouseAccountsIndex',
}
</script>